// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var CheckboxStatus$ReactHooksTemplate = require("./checkboxStatus.res.js");

function getPermissionCategoryName(x) {
  switch (x) {
    case "ShowDashboard" :
        return "show_dashboard";
    case "CreateTicket" :
        return "create_ticket";
    case "ManageTickets" :
        return "manage_ticket";
    case "ResolveTickets" :
        return "resolve_ticket";
    case "AssignTickets" :
        return "assign_tickets";
    case "SelfAssignTickets" :
        return "self_assign_tickets";
    case "BuildSurvey" :
        return "build_survey";
    case "DeleteSurvey" :
        return "delete_survey";
    case "ShowSurvey" :
        return "show_survey";
    case "AddUser" :
        return "add_user";
    case "DeleteUser" :
        return "delete_user";
    case "UpdateUser" :
        return "update_user";
    case "ShowUser" :
        return "show_user";
    case "AddRole" :
        return "add_role";
    case "DeleteRole" :
        return "delete_role";
    case "UpdateRole" :
        return "update_role";
    case "ShowRole" :
        return "show_role";
    case "ShowCampaign" :
        return "show_campaign";
    case "CreateCampaign" :
        return "create_campaign";
    case "ShowQuickSurvey" :
        return "show_quick_survey";
    case "ShowDistribution" :
        return "show_distribution";
    case "CreateDistribution" :
        return "create_distribution";
    case "ShowReport" :
        return "show_report";
    case "CreateReport" :
        return "create_report";
    case "EditReport" :
        return "edit_report";
    case "DeleteReport" :
        return "delete_report";
    case "EditTextCategories" :
        return "edit_text_categories";
    case "ShowKpi" :
        return "show_kpi";
    case "AddKpi" :
        return "add_kpi";
    case "UpdateKpi" :
        return "update_kpi";
    case "DeleteKpi" :
        return "delete_kpi";
    case "CreateDataField" :
        return "create_data_field";
    case "ManageSettings" :
        return "manage_settings";
    case "MaskValues" :
        return "mask_values";
    case "ViewMaskValues" :
        return "view_mask_values";
    
  }
}

function status(t) {
  if (t.TAG === "Capability") {
    return CheckboxStatus$ReactHooksTemplate.fromBool(t._1);
  } else {
    return CheckboxStatus$ReactHooksTemplate.reduce(Belt_List.map(t._1, status));
  }
}

function postOrder(onCapability, onGroup, tree) {
  if (tree.TAG === "Capability") {
    return Curry._2(onCapability, tree._0, CheckboxStatus$ReactHooksTemplate.fromBool(tree._1));
  } else {
    return Curry._3(onGroup, tree._0, status(tree), Belt_List.map(tree._1, (function (param) {
                      return postOrder(onCapability, onGroup, param);
                    })));
  }
}

function enabledCapabilities(xs, tree) {
  if (tree.TAG === "Capability") {
    if (tree._1) {
      return {
              hd: tree._0,
              tl: xs
            };
    } else {
      return xs;
    }
  } else {
    return List.fold_left(enabledCapabilities, xs, tree._1);
  }
}

function disabledCapabilities(xs, tree) {
  if (tree.TAG === "Capability") {
    if (tree._1) {
      return xs;
    } else {
      return {
              hd: tree._0,
              tl: xs
            };
    }
  } else {
    return List.fold_left(disabledCapabilities, xs, tree._1);
  }
}

function hasCapability(permissionCategory, treeList) {
  var checkCapabilityList = List.filter(function (name) {
          return name === getPermissionCategoryName(permissionCategory);
        })(List.fold_left(enabledCapabilities, /* [] */0, treeList));
  return Belt_List.head(checkCapabilityList) !== undefined;
}

function setEnabled(x, t) {
  if (t.TAG === "Capability") {
    return {
            TAG: "Capability",
            _0: t._0,
            _1: x
          };
  } else {
    return {
            TAG: "Group",
            _0: t._0,
            _1: Belt_List.map(t._1, (function (param) {
                    return setEnabled(x, param);
                  }))
          };
  }
}

function toggle(x, t) {
  if (t.TAG === "Capability") {
    var capability = t._0;
    if (x === capability) {
      return {
              TAG: "Capability",
              _0: capability,
              _1: !t._1
            };
    } else {
      return t;
    }
  }
  var children = t._1;
  var group = t._0;
  if (x !== group) {
    return {
            TAG: "Group",
            _0: group,
            _1: Belt_List.map(children, (function (param) {
                    return toggle(x, param);
                  }))
          };
  }
  var checked = CheckboxStatus$ReactHooksTemplate.toBool(status(t));
  var partial_arg = !checked;
  return {
          TAG: "Group",
          _0: group,
          _1: Belt_List.map(children, (function (param) {
                  return setEnabled(partial_arg, param);
                }))
        };
}

function enableCapability(name, t) {
  if (t.TAG !== "Capability") {
    return {
            TAG: "Group",
            _0: t._0,
            _1: Belt_List.map(t._1, (function (param) {
                    return enableCapability(name, param);
                  }))
          };
  }
  var capability = t._0;
  if (capability === name) {
    return {
            TAG: "Capability",
            _0: capability,
            _1: true
          };
  } else {
    return t;
  }
}

function applyReportPermissionDependencies(trees) {
  var enabled = List.fold_left(enabledCapabilities, /* [] */0, trees);
  var hasReportCrud = List.exists((function (cap) {
          return List.mem(cap, enabled);
        }), {
        hd: "create_report",
        tl: {
          hd: "edit_report",
          tl: {
            hd: "delete_report",
            tl: /* [] */0
          }
        }
      });
  if (hasReportCrud && !List.mem("show_report", enabled)) {
    return Belt_List.map(trees, (function (tree) {
                  return enableCapability("show_report", tree);
                }));
  } else {
    return trees;
  }
}

function disableCapability(name, t) {
  if (t.TAG !== "Capability") {
    return {
            TAG: "Group",
            _0: t._0,
            _1: Belt_List.map(t._1, (function (param) {
                    return disableCapability(name, param);
                  }))
          };
  }
  var capability = t._0;
  if (capability === name) {
    return {
            TAG: "Capability",
            _0: capability,
            _1: false
          };
  } else {
    return t;
  }
}

function applyMaskPermissionDependencies(trees) {
  var enabled = List.fold_left(enabledCapabilities, /* [] */0, trees);
  var hasManageSettings = List.mem("manage_settings", enabled);
  var hasMaskValues = List.mem("mask_values", enabled);
  if (hasMaskValues && !hasManageSettings) {
    return Belt_List.map(trees, (function (tree) {
                  return disableCapability("mask_values", tree);
                }));
  } else {
    return trees;
  }
}

function decodeCapability(json) {
  var capability = Json_decode.field("capability", Json_decode.string, json);
  var enabled = Json_decode.field("enabled", Json_decode.bool, json);
  return {
          TAG: "Capability",
          _0: capability,
          _1: enabled
        };
}

function decodeGroup(json) {
  var group = Json_decode.field("group", Json_decode.string, json);
  var children = Json_decode.field("children", (function (param) {
          return Json_decode.list(decodeChild, param);
        }), json);
  return {
          TAG: "Group",
          _0: group,
          _1: children
        };
}

function decodeChild(json) {
  return Json_decode.either(decodeGroup, decodeCapability)(json);
}

function decode(json) {
  return Json_decode.field("permissions", (function (param) {
                return Json_decode.list(decodeChild, param);
              }), json);
}

function emptyPermission(param) {
  return /* [] */0;
}

exports.postOrder = postOrder;
exports.enabledCapabilities = enabledCapabilities;
exports.disabledCapabilities = disabledCapabilities;
exports.status = status;
exports.toggle = toggle;
exports.enableCapability = enableCapability;
exports.disableCapability = disableCapability;
exports.applyReportPermissionDependencies = applyReportPermissionDependencies;
exports.applyMaskPermissionDependencies = applyMaskPermissionDependencies;
exports.decode = decode;
exports.emptyPermission = emptyPermission;
exports.hasCapability = hasCapability;
/* No side effect */
